import { useEffect, useRef, useState } from 'react';

export default function useStablePanelHeight(resetKey) {
  const ref = useRef(null);
  const [minHeight, setMinHeight] = useState(0);

  useEffect(() => setMinHeight(0), [resetKey]);
  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const measure = () => setMinHeight((height) => Math.max(height, element.scrollHeight));
    const frame = window.requestAnimationFrame(measure);
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(element);
    return () => { window.cancelAnimationFrame(frame); observer?.disconnect(); };
  }, [resetKey]);

  return { ref, minHeight };
}
